import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useUnAssignCourierToOrdersMutation = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();

  const mutation = useMutation({
    mutationFn: ({ orders }: any) =>
      patch(
        `internal/secure/pos/v1/orders/information/couriers/unassign/multiple/orders/to/courier/id/${branchId}`,
        {
          orders,
        }
      ),
    onSuccess: () => {
      toast.success(t("success.update"));
    },
  });

  return mutation;
};

export default useUnAssignCourierToOrdersMutation;
